export default __webpack_public_path__ + "static/media/OTHER_TRIVIA.8096bf45.svg";